import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Refund Policy</h1>
        <Card className="p-8 prose max-w-none text-gray-700">
          <h2 className="font-bold text-lg">Digital Career Products</h2>
          <p>Daily UAE Jobs delivers digital career-support products including ATS CV analysis, professional CV optimization, LinkedIn guidance, interview preparation, and templates. Because these are digital services delivered instantly, refunds are considered case-by-case.</p>

          <h2 className="font-bold text-lg mt-4">Eligibility</h2>
          <ul className="list-disc pl-6">
            <li>If your paid product was not delivered within 72 hours despite payment verification, you are eligible for a full refund.</li>
            <li>If your CV was not optimized as described in the plan, you are eligible for a re-work or refund.</li>
            <li>Requests made after your final PDF/DOCX has been downloaded are not eligible.</li>
            <li>Referral outcomes are not guaranteed and are not refundable.</li>
          </ul>

          <h2 className="font-bold text-lg mt-4">How to Request</h2>
          <p>Email Admin@dailyuaejobs.com or WhatsApp +971 52 131 0804 with your payment reference and reason. Refunds, when approved, are processed to the original payment method within 7–14 business days.</p>

          <p className="text-xs text-gray-500 mt-6 pt-4 border-t">
            Daily UAE Jobs is a career support platform, not a recruitment agency. Payment processing and support are handled by Nishu4shaku Digital Marketing Agency.
          </p>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
